import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './components/login/login.component';
import { CadastroComponent } from './components/cadastro/cadastro.component';
import { CriarSenhaComponent } from './components/criar-senha/criar-senha.component';
import { RecuperarSenhaComponent } from './components/recuperar-senha/recuperar-senha.component';
import { ConfirmarEmailComponent } from './components/confirmar-email/confirmar-email.component';
import { RedefinirSenhaComponent } from './components/redefinir-senha/redefinir-senha.component';
import { EmailConfirmadoComponent } from './components/email-confirmado/email-confirmado.component';
import { EmailConfirmationComponent } from './components/email-confirmation/email-confirmation.component';
import { RegisterPasswordComponent } from './components/register-password/register-password.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    data: { title: 'PagueLá' }
  },
  {
    path: 'login/email-confirmation',
    data: { title: 'Verificar Identidade' },
    component: EmailConfirmationComponent
  },
  {
    path: 'login/register-password',
    data: { title: 'Cadastrar Senha' },
    component: RegisterPasswordComponent
  },
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'Login' }
  },
  {
    path: 'login/:email',
    component: LoginComponent,
    data: { title: 'Login' }
  },
  {
    path: 'cadastro',
    component: CadastroComponent,
    data: { title: 'Cadastro' }
  },
  {
    path: 'recuperar-senha',
    component: RecuperarSenhaComponent,
    data: { title: 'Recuperar Senha' }
  },
  {
    path: 'recuperar-senha/:email',
    component: RecuperarSenhaComponent,
    data: { title: 'Recuperar Senha' }
  },
  {
    path: 'confirmar-email/:email',
    component: ConfirmarEmailComponent,
    data: { title: 'Confirmar Email' }
  },
  {
    path: 'email-confirmado/:email',
    component: EmailConfirmadoComponent,
    data: { title: 'Email Confirmado' }
  },
  {
    path: 'redefinir-senha/:id/:code',
    component: RedefinirSenhaComponent,
    data: { title: 'Redefinir Senha' }
  },
  {
    path: 'criar-senha/:id/:code',
    component: CriarSenhaComponent,
    data: { title: 'Criar Senha' }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AuthRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/modules/auth/auth-routing.module.ts